import { createQueryKeys } from '@lukemorales/query-key-factory'

import { getDrafts } from '~/services/draft-services'

export const draftQueries = createQueryKeys('drafts', {
  listAll: () => ({
    queryKey: ['listAll'],
    queryFn: async () => await getDrafts(),
  }),
})
